import React, { useContext } from 'react';
import { ShippingBanner } from '../components/ShippingBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { NavigationContext, CartContext } from '../App';
import { ChevronLeft, Minus, Plus, X, ShoppingBag, Truck, ArrowRight } from 'lucide-react';
export function CartPage() {
  const {
    navigate
  } = useContext(NavigationContext);
  const {
    cart,
    updateQuantity,
    removeFromCart,
    cartTotal,
    cartCount
  } = useContext(CartContext);
  const subtotal = cartTotal;
  const shipping = subtotal >= 75 ? 0 : 8.95;
  const tax = subtotal * 0.0825;
  const total = subtotal + shipping + tax;
  if (cart.length === 0) {
    return <div className="min-h-screen flex flex-col bg-[#FAFAFA]" data-id="element-560">
        <ShippingBanner data-id="element-561" />
        <Navbar data-id="element-562" />
        <main className="flex-grow py-12 lg:py-20" data-id="element-563">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center" data-id="element-564">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#F5F5F5] flex items-center justify-center" data-id="element-565">
              <ShoppingBag size={32} className="text-[#6B6B6B]" strokeWidth={1.5} data-id="element-566" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-['Playfair_Display'] text-[#1A1A1A] mb-3" data-id="element-567">
              Your Cart is Empty
            </h1>
            <p className="text-sm sm:text-base text-[#6B6B6B] font-['Raleway'] mb-8 max-w-md mx-auto" data-id="element-568">
              Looks like you haven't added anything to your cart yet. Explore
              our collection and find something you'll love.
            </p>
            <Button onClick={() => navigate('shop')} variant="secondary" data-id="element-569">
              Start Shopping
            </Button>
          </div>
        </main>
        <Footer data-id="element-570" />
      </div>;
  }
  return <div className="min-h-screen flex flex-col bg-[#FAFAFA]" data-id="element-571">
      <ShippingBanner data-id="element-572" />
      <Navbar data-id="element-573" />

      <main className="flex-grow py-4 sm:py-6 lg:py-10" data-id="element-574">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-575">
          {/* Back Link */}
          <button onClick={() => navigate('shop')} className="inline-flex items-center gap-1 text-xs text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors mb-6 sm:mb-8 uppercase tracking-wider" data-id="element-576">
            <ChevronLeft size={14} data-id="element-577" /> Continue Shopping
          </button>

          {/* Page Header */}
          <div className="mb-6 sm:mb-10" data-id="element-578">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-579">
              Shopping Cart
            </h1>
            <p className="text-sm text-[#6B6B6B] font-['Raleway'] mt-2" data-id="element-580">
              {cartCount} {cartCount === 1 ? 'item' : 'items'} in your cart
            </p>
            <div className="w-10 h-[2px] bg-[#D4A853] mt-3" data-id="element-581" />
          </div>

          <div className="flex flex-col lg:grid lg:grid-cols-12 gap-6 lg:gap-10" data-id="element-582">
            {/* Cart Items */}
            <div className="lg:col-span-8" data-id="element-583">
              <div className="bg-white border border-[#E8E8E8]" data-id="element-584">
                {/* Header - Desktop */}
                <div className="hidden sm:grid sm:grid-cols-12 gap-4 px-6 py-4 border-b border-[#E8E8E8] text-xs font-medium text-[#6B6B6B] uppercase tracking-wider font-['Raleway']" data-id="element-585">
                  <div className="col-span-6" data-id="element-586">Product</div>
                  <div className="col-span-2 text-center" data-id="element-587">Quantity</div>
                  <div className="col-span-2 text-center" data-id="element-588">Price</div>
                  <div className="col-span-2 text-right" data-id="element-589">Total</div>
                </div>

                {/* Cart Items */}
                <div className="divide-y divide-[#E8E8E8]" data-id="element-590">
                  {cart.map(item => <div key={`${item.id}-${item.size}-${item.color}`} className="p-4 sm:p-6" data-id="element-591">
                      <div className="flex gap-4 sm:grid sm:grid-cols-12 sm:gap-4 sm:items-center" data-id="element-592">
                        {/* Product Info */}
                        <div className="flex gap-4 flex-1 sm:col-span-6" data-id="element-593">
                          <div className="w-20 h-24 sm:w-24 sm:h-28 bg-[#F5F5F5] flex-shrink-0 overflow-hidden" data-id="element-594">
                            {typeof item.image === 'string' && item.image.startsWith('http') ? <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-595" /> : <div className={`w-full h-full ${item.image}`} data-id="element-596" />}
                          </div>
                          <div className="flex-1 min-w-0" data-id="element-597">
                            <h3 className="text-sm sm:text-base font-['Playfair_Display'] text-[#1A1A1A] leading-snug mb-1" data-id="element-598">
                              {item.name}
                            </h3>
                            <p className="text-xs text-[#6B6B6B] font-['Raleway'] mb-2" data-id="element-599">
                              Size: {item.size} · Color: {item.color}
                            </p>
                            <p className="text-sm font-medium text-[#1A1A1A] font-['Raleway'] sm:hidden" data-id="element-600">
                              ${item.price.toFixed(2)}
                            </p>
                            <button onClick={() => removeFromCart(item.id, item.size, item.color)} className="inline-flex items-center gap-1 text-xs text-[#6B6B6B] hover:text-red-500 transition-colors mt-2 sm:mt-3" data-id="element-601">
                              <X size={12} strokeWidth={1.5} data-id="element-602" />
                              Remove
                            </button>
                          </div>
                        </div>

                        {/* Quantity - Mobile shows inline */}
                        <div className="sm:col-span-2 flex sm:justify-center" data-id="element-603">
                          <div className="inline-flex items-center border border-[#E8E8E8] h-9 sm:h-10" data-id="element-604">
                            <button onClick={() => updateQuantity(item.id, item.size, item.color, item.quantity - 1)} className="w-9 sm:w-10 h-full flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] hover:bg-[#F5F5F5] transition-colors" aria-label="Decrease quantity" data-id="element-605">
                              <Minus size={14} data-id="element-606" />
                            </button>
                            <span className="w-10 sm:w-12 text-center font-medium text-[#1A1A1A] text-sm" data-id="element-607">
                              {item.quantity}
                            </span>
                            <button onClick={() => updateQuantity(item.id, item.size, item.color, item.quantity + 1)} className="w-9 sm:w-10 h-full flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] hover:bg-[#F5F5F5] transition-colors" aria-label="Increase quantity" data-id="element-608">
                              <Plus size={14} data-id="element-609" />
                            </button>
                          </div>
                        </div>

                        {/* Price - Desktop only */}
                        <div className="hidden sm:block sm:col-span-2 text-center" data-id="element-610">
                          <p className="text-sm text-[#1A1A1A] font-['Raleway']" data-id="element-611">
                            ${item.price.toFixed(2)}
                          </p>
                        </div>

                        {/* Total - Desktop only */}
                        <div className="hidden sm:block sm:col-span-2 text-right" data-id="element-612">
                          <p className="text-sm font-medium text-[#1A1A1A] font-['Raleway']" data-id="element-613">
                            ${(item.price * item.quantity).toFixed(2)}
                          </p>
                        </div>
                      </div>

                      {/* Mobile Total */}
                      <div className="flex justify-between items-center mt-4 pt-4 border-t border-[#E8E8E8] sm:hidden" data-id="element-614">
                        <span className="text-xs text-[#6B6B6B] font-['Raleway']" data-id="element-615">
                          Item Total
                        </span>
                        <span className="text-sm font-medium text-[#1A1A1A] font-['Raleway']" data-id="element-616">
                          ${(item.price * item.quantity).toFixed(2)}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Continue Shopping Link */}
              <div className="mt-6" data-id="element-617">
                <button onClick={() => navigate('shop')} className="inline-flex items-center gap-2 text-sm text-[#6B6B6B] hover:text-[#D4A853] transition-colors font-['Raleway']" data-id="element-618">
                  <ChevronLeft size={16} data-id="element-619" />
                  Continue Shopping
                </button>
              </div>
            </div>

            {/* Order Summary */}
            <div className="lg:col-span-4" data-id="element-620">
              <div className="bg-white border border-[#E8E8E8] p-5 sm:p-6 sticky top-24" data-id="element-621">
                <h2 className="text-lg font-['Playfair_Display'] text-[#1A1A1A] mb-5" data-id="element-622">
                  Order Summary
                </h2>

                <div className="space-y-3 text-sm font-['Raleway']" data-id="element-623">
                  <div className="flex justify-between" data-id="element-624">
                    <span className="text-[#6B6B6B]" data-id="element-625">
                      Subtotal ({cartCount} items)
                    </span>
                    <span className="text-[#1A1A1A]" data-id="element-626">
                      ${subtotal.toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-627">
                    <span className="text-[#6B6B6B]" data-id="element-628">Estimated Shipping</span>
                    <span className={shipping === 0 ? 'text-green-600 font-medium' : 'text-[#1A1A1A]'} data-id="element-629">
                      {shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-630">
                    <span className="text-[#6B6B6B]" data-id="element-631">Estimated Tax</span>
                    <span className="text-[#1A1A1A]" data-id="element-632">${tax.toFixed(2)}</span>
                  </div>

                  <div className="flex justify-between pt-4 mt-2 border-t border-[#E8E8E8]" data-id="element-633">
                    <span className="font-semibold text-[#1A1A1A]" data-id="element-634">
                      Estimated Total
                    </span>
                    <span className="text-xl font-bold text-[#D4A853]" data-id="element-635">
                      ${total.toFixed(2)}
                    </span>
                  </div>
                </div>

                {subtotal < 75 && <div className="mt-4 p-3 bg-[#D4A853]/10 rounded" data-id="element-636">
                    <p className="text-xs text-[#1A1A1A] font-['Raleway'] flex items-center gap-2" data-id="element-637">
                      <Truck size={14} className="text-[#D4A853]" data-id="element-638" />
                      Add{' '}
                      <span className="font-semibold text-[#D4A853]" data-id="element-639">
                        ${(75 - subtotal).toFixed(2)}
                      </span>{' '}
                      more for free shipping
                    </p>
                  </div>}

                <Button onClick={() => navigate('checkout')} variant="secondary" className="w-full mt-6 h-12 sm:h-[52px] text-xs tracking-[0.2em] font-semibold group" data-id="element-640">
                  Proceed to Checkout
                  <ArrowRight size={14} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-641" />
                </Button>

                <p className="text-[10px] text-[#6B6B6B] font-['Raleway'] text-center mt-4" data-id="element-642">
                  Shipping & taxes calculated at checkout
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-643" />
    </div>;
}